@use "~theme/typography";
@use "~theme/breakpoints";

$grid-desktop-width: 922px;
$arrow-width: 60px;

.grid {
  display: grid;
  grid-template-columns: 60px repeat(7, 1fr) 60px;
  grid-template-areas:
    "prevArrow sunday monday tuesday wednesday thursday friday saturday nextArrow"
    ". slots slots slots slots slots slots slots ."
    "waitlist waitlist waitlist waitlist waitlist waitlist waitlist waitlist waitlist";
  width: $grid-desktop-width;
  margin: 0 auto;
  background-color: var(--white);
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 6px var(--gray-01);

  @include breakpoints.desktop {
    width: $grid-desktop-width;
  }
}

.waitlistCta {
  grid-area: waitlist;
  margin-top: 12px;
}

.dateHeader {
  padding: 12px 0;
  height: 60px;
  background-color: var(--blue-03);
}

.weekDay {
  @include typography.body;
  display: block;
  text-align: center;
}

.monthDay {
  @include typography.body-semibold;
  display: block;
  text-align: center;
}

.arrow {
  background-color: var(--blue-03);
  display: flex;
  align-items: center;
  justify-content: center;
  width: $arrow-width;
}

.doctor {
  @include typography.heading4;
  text-align: center;
  color: var(--blue-01);
  flex: 1;
}

.date {
  text-transform: none;
}

.tableHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: $grid-desktop-width;
  margin: auto;
}

.headerArrow {
  width: $arrow-width;
  display: flex;
  justify-content: center;
  align-items: center;

  @include breakpoints.desktop {
    display: none;
  }
}
